import {
    ConversationList,
    ConversationsListState,
    ConversationsListError
}                             from '../../reduxTypes';
import { Reducer, Action }    from 'redux';
import ActionTypes            from '../../ActionTypes';
import { censorProfanity }    from '../../helpers/stringUtils';
import { MessageActions }     from '../../types';

interface LoadConversationsListErrorActionPayload extends Action {
    error: ConversationsListError
}

interface ConversationsListSuccessActionPayload extends Action {
    conversationsList: ConversationList
}

interface ConversationsListResetUnreadActionPayload extends Action {
    conversationId: string
}

export const defaultState: ConversationsListState = {
    conversationsList: [],
    loading: true,
    unread: 0,
};

// Clean profanity in each conversation's last_message so that 'crap' becomes '****'
export const cleanLastMessageProfanity = conversation => {
    if (conversation.last_message.action === MessageActions.SEND) {
        return conversation;
    }

    return {
        ...conversation,
        last_message: {
            ...conversation.last_message,
            content: censorProfanity(conversation.last_message.content)
        }
    };
};

const ConversastionsListReducer: Reducer<ConversationsListState> = (state: ConversationsListState = defaultState, action: Action): ConversationsListState => {
    switch (action.type) {
        case ActionTypes.CONVERSATIONSLIST_LOAD_MESSAGE:
            return {
                ...state,
                loading: true
            };

        case ActionTypes.CONVERSATIONSLIST_LOAD_ERROR:
            return {
                ...state,
                loading: false,
                error: (action as LoadConversationsListErrorActionPayload).error
            };

        case ActionTypes.CONVERSATIONSLIST_LOAD_SUCCESS:
            const dirtyConversationsList = (action as ConversationsListSuccessActionPayload).conversationsList;
            const cleanConversationsList = dirtyConversationsList.map(cleanLastMessageProfanity);
            const unreadConversations = cleanConversationsList.map(conversation => Number(conversation.unread_message_count) !== 0 ? true : null);
            return {
                conversationsList: cleanConversationsList,
                unread: unreadConversations.filter(conversation => !!conversation).length,
            };

        case ActionTypes.CONVERSATIONSLIST_RESET_UNREAD:
            const { conversationId } = (action as ConversationsListResetUnreadActionPayload);

            return {
                conversationsList: (state as ConversationsListState).conversationsList.map((conversation) => {
                    if (conversation.id === conversationId) {
                        conversation.unread_message_count = '0';
                        state.unread--;
                        return conversation;
                    }
                    return conversation;
                })
            };

        default:
            return state;
    }
};

export default ConversastionsListReducer;



// WEBPACK FOOTER //
// ./src/sections/ConversationsList/ConversationsListReducer.ts